import styled from '@emotion/styled'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { isEmpty, pathOr } from 'ramda'
import React from 'react'

import { FormSpecs } from '@/app/types'

import { UploadConfigsWithOptionalKey } from '../../types'
import { filterUnchecked } from './actions'

type Configs = UploadConfigsWithOptionalKey

type Props = {
  specs: FormSpecs
  configs: Configs | null
  statuses: boolean[]
}

const getCellValue = (field: string, samples: string[], columns: Configs) => {
  const index =
    (pathOr(false, ['fieldsToColumns', field], columns) as string | false) ||
    (pathOr(false, ['customFieldsToColumns', field], columns) as string | false)

  return index !== false ? samples[Number(index)] : ''
}

const ContactsUploadReviewContent: React.FC<Props> = ({ configs, specs, statuses }) => {
  if (!configs) {
    return null
  }

  const columns = filterUnchecked(configs, specs, statuses)

  return (
    <div>
      <TitleText>Please review and confirm your upload</TitleText>
      <TableWrap>
        <Table>
          <TableHead>
            <TableRow>
              {Object.keys(specs).map((field) => (
                <TableCell key={field}>{specs[field].label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {!isEmpty(columns) &&
              columns.sampleData.map((samples, i) => (
                <TableRow key={i}>
                  {Object.keys(specs).map((field) => (
                    <TableCell key={field}>{getCellValue(field, samples, columns)}</TableCell>
                  ))}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableWrap>
    </div>
  )
}

const TableWrap = styled('div')({
  width: '100%',
  overflow: 'scroll',
})

const TitleText = styled(Typography)({
  textAlign: 'center',
  margin: '2rem 0 4rem',
})

export default ContactsUploadReviewContent
